import { useContext, type ReactNode } from "react";
import { StyleSheet, Text } from "react-native";

import {
  fonts,
  typography,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";
import { ButtonContext } from "./button-context";

export function ButtonText({
  children,
  tone,
}: {
  children: ReactNode;
  tone?: "default" | "danger" | "light";
}) {
  const stylesheet = useThemedStyles(makeStyles);
  const variant = useContext(ButtonContext);
  const style =
    tone === "danger" || variant === "danger"
      ? stylesheet.danger
      : tone === "light" || variant === "primary"
        ? stylesheet.light
        : variant === "link"
          ? stylesheet.link
          : stylesheet.default;
  return <Text style={style}>{children}</Text>;
}

const baseText = { fontSize: 14, lineHeight: typography.label.lineHeight };

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    default: {
      ...baseText,
      color: colors.foreground,
      fontFamily: fonts.medium,
    },
    light: {
      ...baseText,
      color: colors.primaryForeground,
      fontFamily: fonts.semibold,
    },
    link: {
      ...baseText,
      color: colors.primary,
      fontFamily: fonts.medium,
    },
    danger: {
      ...baseText,
      color: colors.danger,
      fontFamily: fonts.medium,
    },
  });
